import React from "react";
import "./TheStudentDashboard.css";
import { Skeleton } from "@mui/material";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EditIcon from '@mui/icons-material/Edit';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const PaperCounts = ({ availablePaperCount, enrolledPaperCount, completedPaperCount, student_dashboard_initial_loading }) => {

  // Use enrolled colors for all cards (bg, title color, text color)
  const enrolledBg = '#FFF7ED';
  const enrolledTitleColor = '#a67840';
  const enrolledTextColor = '#8c8c8c';

  const examCategories = [
    {
      id: 'available',
      label: 'Available',
      count: availablePaperCount,
      bgColor: enrolledBg,
      iconColor: enrolledTitleColor,
      textColor: enrolledTextColor,
      Icon: MenuBookIcon
    },
    {
      id: 'enrolled',
      label: 'Enrolled',
      count: enrolledPaperCount,
      bgColor: enrolledBg,
      iconColor: enrolledTitleColor,
      textColor: enrolledTextColor,
      Icon: EditIcon
    },
    {
      id: 'completed',
      label: 'Completed',
      count: completedPaperCount,
      bgColor: enrolledBg,
      iconColor: enrolledTitleColor,
      textColor: enrolledTextColor,
      Icon: AssignmentTurnedInIcon
    }
  ];

  return (
    <div className="exam-counts-container">
      <h6 className="exam-counts-title">Exam Counts</h6>

      <div className="exam-counts-grid">
        {student_dashboard_initial_loading ? (
          <>
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                sx={{
                  height: '180px',
                  borderRadius: "16px",
                  flex: '1 1 calc(33.33% - 12px)',
                  minWidth: '140px'
                }}
                variant="rectangular"
                animation="wave"
              />
            ))}
          </>
        ) : (
          examCategories.map((category) => (
            <div
              key={category.id}
              className="exam-count-item"
              style={{ ['--start-color']: category.bgColor }}
            >
              <div className="icon-wrapper">
                <category.Icon sx={{ fontSize: 40, color: category.iconColor }} aria-label={`${category.label} icon`} />
              </div>

              <h4 className="exam-category-name" style={{ color: category.iconColor }}>
                {category.label}
              </h4>
              <p className="exam-task-remaining" style={{ color: category.textColor }}>
                {category.count > 0
                  ? `${category.count} ${category.count === 1 ? 'Task' : 'Exams'}`
                  : 'No assignment yet'}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PaperCounts;